const LangRedeemPromocode = {
  "redeemPromocode._title": ["Enter promo code", "NHẬP MÃ KHUYẾN MÃI"],
  "redeemPromocode.form.label._code": [
    "Promo codes are case-sensitive.",
    "Mã khuyến mãi có phân biệt chữ hoa và chữ thường."
  ]
};
export default LangRedeemPromocode;
